import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getDateFormatted,
  formatDate,
  getLocalStorageItem,
} from '@shared/utils'


interface ScheduleBannerProps {
  date: string | Date | null | undefined
  noDigital: boolean
  dateBannerClasses?: string
  isMod: boolean
  appointmentDateWatched: string | Date | null | undefined
}

export const ScheduleBanner: React.FC<ScheduleBannerProps> = ({
  date,
  noDigital,
  isMod,
  appointmentDateWatched,
}) => {
  const { t } = useTranslation()
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    if (appointmentDateWatched) {
      setMessage(t('common:dateBannerTitle'))
    } else {
      setMessage(t('common:lastDateTitle'))
    }
  }, [appointmentDateWatched, t])

  const [dateSelectedFormatted, setDateSelectedFormatted] = useState<string | null>(null)
  const [timeSlotSelected] = useState<string | null>(getLocalStorageItem('slotsSelected'))

  useEffect(() => {
    if (date) {
      try {
        const formattedDate = getDateFormatted(date, 'D MMMM Y')
        const slotSelected = getLocalStorageItem('slotsSelected') || getLocalStorageItem('slotDelected')
        
        console.log('📅 SR ScheduleBanner formatting:', {
          originalDate: date,
          formattedDate,
          slotSelected,
          noDigital,
          dateType: typeof date
        })
        
        if (slotSelected) {
          // User selected a slot - use localStorage slot time
          setDateSelectedFormatted(`${formattedDate} - ${slotSelected}`)
        } else if (date instanceof Date || (typeof date === 'string' && date.includes('T'))) {
          // Date comes from policy (firstAppointmentDate) and includes time
          try {
            const dateObj = date instanceof Date ? date : new Date(date)
            const timeFormatted = getDateFormatted(dateObj, 'HH:mm')
            setDateSelectedFormatted(`${formattedDate} - ${timeFormatted}`)
            console.log('📅 SR ScheduleBanner: Using policy time:', timeFormatted)
          } catch (error) {
            console.warn('Error formatting policy time:', error)
            setDateSelectedFormatted(formattedDate)
          }
        } else {
          // Just date without time
          setDateSelectedFormatted(formattedDate)
        }
      } catch (error) {
        console.warn('Error formatting date in SR ScheduleBanner:', error)
        // Fallback to original format
        const fallbackFormatted = formatDate(date)
        const slotSelected = getLocalStorageItem('slotsSelected')
        if (slotSelected) {
          setDateSelectedFormatted(`${fallbackFormatted} - ${slotSelected}`)
        } else {
          setDateSelectedFormatted(fallbackFormatted)
        }
      }
    } else {
      setDateSelectedFormatted(null)
    }
  }, [date, timeSlotSelected, noDigital])

  return (
    <div className='p-6 text-center text-dark-gray bg-modal-overlay mb-9' data-testid="ba-agenda-banner">
      <div className='text-sm'>
        {isMod ? message : t('common:dateBannerTitle')}
      </div>
      <div className='capitalize text-2xl font-semibold' data-testid="ba-agenda-banner-date">
        {dateSelectedFormatted}
      </div>
    </div>
  )
}
